import s from "./blockedDomains.js";
const r = (t) => new RegExp([
  "^([\\w+.-]+)@(\\[(\\d{1,3}\\.){3}|",
  "(([a-zA-Z\\d-]+\\.)+))([a-zA-Z]{2,63}|\\d{1,3})(\\]?)$"
].join("")).test(t) && a(t), a = (t) => {
  const e = o(t);
  return e && !s.includes(e);
}, o = (t) => {
  var e, u, n;
  return (n = (u = (e = t == null ? void 0 : t.split("@")) == null ? void 0 : e[1]) == null ? void 0 : u.split(".")) == null ? void 0 : n[0];
}, F = (t) => /^[a-zA-Z\u00C0-\u00FF\u3000-\u303F\u3400-\u4DBF\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF ]{2,30}$/.test(t), c = (t) => /^[A-Za-z\d ]{2,30}$/.test(t), i = (t) => /^\+?\d{7,15}$/.test(t), d = (t) => /^[https:\/\/]{8}(?!\.)(?!.*\.$)(?!.*\.\.)(?!(?:.*?\.){3})[-.a-z0-9]{2,35}\.[a-z]{2,6}$/.test(t), p = { phoneNumberField: i, companyNameField: c, nameField: F, emailField: r, websiteField: d }, l = (t = {}) => {
  const e = (t == null ? void 0 : t.required) ?? !1, u = !!(t != null && t.validate);
  switch (!0) {
    case (!t.value && !e):
      return !0;
    case (t.value && u):
      return t.validate(t.value);
    default:
      return !!t.value;
  }
};
export {
  p as formValidationRules,
  l as isValidFormField
};
